import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { Categoria } from 'my-lib-sanfelici';
import { CategorieService } from 'my-lib-sanfelici';


@Component({
  selector: 'app-categorie-combo',
  templateUrl: './categorie-combo.component.html',
  styleUrls: ['./categorie-combo.component.scss']
})
export class CategorieComboComponent implements OnInit {
categorie: Observable<Categoria[]>;
categoria: Categoria;
@Output() oncambia = new EventEmitter<Categoria>();
  constructor(private categorieservice: CategorieService) { }
cambia(categoria: Categoria){
this.oncambia.emit(categoria);
}
  ngOnInit() {
this.categorie = this.categorieservice.list();

  }

}
